"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FedActionsContext = exports.FedDndContext = exports.FedCnPContext = exports.FedSelectContext = exports.FedExpandContext = exports.FedDBContext = exports.FedSetupContext = exports.FedController = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const GradingMethod_1 = __importDefault(require("@opsbase/lib-grading/GradingMethod"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useDebouncedValue_1 = __importDefault(require("@opsbase/react-hooks/useDebouncedValue"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const react_1 = __importStar(require("react"));
const addQuestions_1 = __importDefault(require("../helpers/addQuestions"));
const addSubQuestions_1 = __importDefault(require("../helpers/addSubQuestions"));
const cloneDB_1 = __importDefault(require("../helpers/cloneDB"));
const cloneQuestion_1 = __importDefault(require("../helpers/cloneQuestion"));
const createEmptyDB_1 = __importDefault(require("../helpers/createEmptyDB"));
const dbToFormQuestions_1 = __importDefault(require("../helpers/dbToFormQuestions"));
const deleteQuestion_1 = __importDefault(require("../helpers/deleteQuestion"));
const formQuestionsToDB_1 = __importDefault(require("../helpers/formQuestionsToDB"));
const getNextQuestion_1 = __importDefault(require("../helpers/getNextQuestion"));
const getPreviousQuestion_1 = __importDefault(require("../helpers/getPreviousQuestion"));
const getQuestionAncestors_1 = require("../helpers/getQuestionAncestors");
const moveQuestion_1 = __importDefault(require("../helpers/moveQuestion"));
const processDB_1 = require("../helpers/processDB");
function FedController(props) {
    var _a;
    const { id = 'form', title = 'FORM', isQuestionSet = false, isScoreEnabled = false, isScorePublic = false, canAllQuestionsBeSkipped = false, showDragPlaceholders = false, gradingMethod = new GradingMethod_1.default(), isGradingPublic = false, allowIssuesAndNotes = false, formConstraints = {}, addLabel = lib_i18n_1.default.t('add-question'), mode = 'edit', form = [], onChangeForm, children, } = props;
    const { defaultQT, defaultSubQT } = calcDefaultQTs(formConstraints);
    const { isAlt, language } = (0, useSysLang_1.default)();
    const [dbCtxChanged, setDbCtxChanged] = (0, react_1.useState)();
    const [selCtxChanged, setSelCtxChanged] = (0, react_1.useState)();
    const [cnpCtxChanged, setCnpCtxChanged] = (0, react_1.useState)();
    const [expCtxChanged, setExpCtxChanged] = (0, react_1.useState)();
    const [dndCtxChanged, setDndCtxChanged] = (0, react_1.useState)();
    const initialized = (0, react_1.useRef)(false);
    const history = (0, react_1.useRef)([(0, createEmptyDB_1.default)(defaultSubQT)]);
    const historyCursor = (0, react_1.useRef)(0);
    const canUndo = (0, react_1.useRef)(false);
    const canRedo = (0, react_1.useRef)(false);
    const selected = (0, react_1.useRef)();
    const fullySelected = (0, react_1.useRef)();
    const treeFocus = (0, react_1.useRef)(true);
    const copied = (0, react_1.useRef)();
    const expands = (0, react_1.useRef)({});
    const dragging = (0, react_1.useRef)();
    //----------------
    // SETUP CONTROLLER
    //----------------
    const setupCtx = (0, react_1.useMemo)(() => ({
        mode,
        id,
        title,
        isQuestionSet,
        canAllQuestionsBeSkipped,
        isScoreEnabled,
        isScorePublic,
        gradingMethod,
        isGradingPublic,
        allowIssuesAndNotes,
        formConstraints,
        addLabel,
        showDragPlaceholders,
    }), [
        mode,
        id,
        title,
        isQuestionSet,
        canAllQuestionsBeSkipped,
        isScoreEnabled,
        isScorePublic,
        gradingMethod,
        isGradingPublic,
        allowIssuesAndNotes,
        formConstraints,
        addLabel,
        showDragPlaceholders,
    ]);
    const init = (0, react_1.useMemo)(() => () => {
        setTimeout(() => {
            const dbForm = !form ? [] : [...form];
            if (dbForm.length <= 0 && mode !== 'view') {
                let config = {};
                config[defaultQT] = {
                    enableNA: canAllQuestionsBeSkipped,
                };
                dbForm.push((0, createFormQuestion_1.default)({ type: defaultQT, config }));
            }
            history.current = [(0, formQuestionsToDB_1.default)(dbForm, defaultSubQT)];
            canUndo.current = false;
            canRedo.current = false;
            setDbCtxChanged(new Date());
        }, 100);
    }, [canAllQuestionsBeSkipped, defaultQT, defaultSubQT, form, mode]);
    //----------------
    // DB CONTROLLER
    //----------------
    (0, react_1.useEffect)(() => {
        if (initialized.current)
            return;
        initialized.current = true;
        init();
    }, [defaultQT, defaultSubQT, form, mode, init]);
    const _getDB = (0, react_1.useMemo)(() => () => history.current[historyCursor.current], []);
    const _getClone = (0, react_1.useMemo)(() => () => (0, cloneDB_1.default)(_getDB()), [_getDB]);
    const _doUpdate = (0, react_1.useMemo)(() => (newDB) => {
        const newHistory = [newDB, ...history.current.slice(historyCursor.current)];
        if (newHistory.length > 100)
            newHistory.pop();
        history.current = newHistory;
        canUndo.current = historyCursor.current < history.current.length - 1;
        canRedo.current = historyCursor.current > 0;
        historyCursor.current = 0;
        onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm((0, dbToFormQuestions_1.default)(newDB));
        setDbCtxChanged(new Date());
    }, [onChangeForm]);
    const _doExpand = (0, react_1.useMemo)(() => (qId, force) => {
        var _a;
        const db = _getDB();
        if (!qId)
            return;
        const q = db.questions[qId];
        // If we don't need to change our expansion
        if (force !== undefined && q.expanded === force)
            return false;
        // Otherwise, change our expansion
        const list = db.lists[q.parentListId];
        q.expanded = force === undefined ? !q.expanded : force;
        expands.current[qId] = q.expanded;
        // If we are now expanded, but our parent is collapsed, we need to expand them
        if (list.parentQId && q.expanded && !db.questions[list.parentQId].expanded)
            _doExpand(list.parentQId, true);
        // We are now collapsed, we should collapse our children
        if (!q.expanded && q.childListIds)
            (_a = q.childListIds) === null || _a === void 0 ? void 0 : _a.forEach(lid => {
                db.lists[lid].childQIds.forEach(qqId => {
                    _doExpand(qqId, false);
                });
            });
        return true;
    }, [_getDB]);
    const doReset = (0, react_1.useMemo)(() => () => {
        init();
    }, [init]);
    const doChangeHistory = (0, react_1.useMemo)(() => dir => {
        if (dir > 0 && !canUndo.current)
            return;
        if (dir < 0 && !canRedo.current)
            return;
        const newDB = history.current[historyCursor.current + dir];
        onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm((0, dbToFormQuestions_1.default)(newDB));
        historyCursor.current = historyCursor.current + dir;
        canUndo.current = historyCursor.current < history.current.length - 1;
        canRedo.current = historyCursor.current > 0;
        setDbCtxChanged(new Date());
    }, [onChangeForm]);
    const doUndo = (0, react_1.useMemo)(() => () => {
        doChangeHistory(+1);
    }, [doChangeHistory]);
    const doRedo = (0, react_1.useMemo)(() => () => {
        doChangeHistory(-1);
    }, [doChangeHistory]);
    const doChangeQuestion = (0, react_1.useMemo)(() => (qId, patch, selectFnc) => {
        var _a;
        const newDB = _getClone();
        // If ADDING question (i.e. setting a title) then we Expand it
        const currentQ = (_a = newDB === null || newDB === void 0 ? void 0 : newDB.questions) === null || _a === void 0 ? void 0 : _a[qId];
        if (!(currentQ === null || currentQ === void 0 ? void 0 : currentQ.title) && !!(patch === null || patch === void 0 ? void 0 : patch.title))
            _doExpand(qId, true);
        if ((currentQ === null || currentQ === void 0 ? void 0 : currentQ.title) && !patch.title)
            _doExpand(qId, false);
        // Handle Language
        if (isAlt && !!patch.title) {
            patch.titleAlt = Object.assign(Object.assign({}, currentQ.titleAlt), { [language]: patch.title });
            // If the english title is blank (or that same as the alt title) we update that too
            // Otherwise, remove the .title prop from the patch
            if (currentQ.title !== '')
                delete patch.title;
        }
        const newQ = (0, processDB_1.updateQuestion)(newDB, qId, patch);
        _doUpdate(newDB);
        if (selectFnc)
            selectFnc(newQ.qId);
    }, [_doExpand, _doUpdate, _getClone, isAlt, language]);
    const doChangeQuestionConfig = (0, react_1.useMemo)(() => (qId, patch, selectFnc) => {
        const newDB = _getClone();
        const newQ = (0, processDB_1.updateQuestionConfig)(newDB, qId, patch);
        _doUpdate(newDB);
        if (selectFnc)
            selectFnc(newQ.qId);
    }, [_doUpdate, _getClone]);
    const doDelete = (0, react_1.useMemo)(() => (qId) => {
        const db = _getDB();
        const prev = (0, getPreviousQuestion_1.default)(db, db.questions[qId]);
        const newDB = _getClone();
        if ((0, deleteQuestion_1.default)(newDB, qId)) {
            if (selected.current === qId) {
                selected.current = prev === null || prev === void 0 ? void 0 : prev.qId;
                setSelCtxChanged(new Date());
            }
            _doUpdate(newDB);
        }
    }, [_doUpdate, _getClone, _getDB]);
    const canAdd = (0, react_1.useMemo)(() => (afterQId) => {
        var _a, _b, _c, _d;
        // Check constraints before adding
        const db = _getDB();
        const parentListId = (_a = db.questions[afterQId]) === null || _a === void 0 ? void 0 : _a.parentListId;
        let constraint;
        if (parentListId === 'root') {
            if (!!(formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints.root)) {
                constraint = formConstraints.root;
                const max = constraint === null || constraint === void 0 ? void 0 : constraint.max;
                const noRootQs = ((_b = db.lists['root'].childQIds) === null || _b === void 0 ? void 0 : _b.length) || 0;
                if (max !== undefined && noRootQs >= max)
                    return false;
            }
        }
        else {
            const parentType = (_d = db.questions[(_c = db.lists[parentListId]) === null || _c === void 0 ? void 0 : _c.parentQId]) === null || _d === void 0 ? void 0 : _d.type;
            if (formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[parentType])
                constraint = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[parentType];
        }
        if (!constraint || !(constraint === null || constraint === void 0 ? void 0 : constraint.types))
            return true;
        return constraint.types.indexOf(defaultQT) >= 0;
    }, [_getDB, formConstraints, defaultQT]);
    const doAdd = (0, react_1.useMemo)(() => (afterQId, selectFnc, afterQuestion = true) => {
        if (!canAdd(afterQId))
            return;
        let config = {};
        config[defaultQT] = {
            enableNA: canAllQuestionsBeSkipped,
        };
        const newQ = (0, createFormQuestion_1.default)({ type: defaultQT, config });
        const newDB = _getClone();
        (0, addQuestions_1.default)(newDB, afterQId, [newQ], afterQuestion);
        _doUpdate(newDB);
        if (selectFnc)
            selectFnc(newQ.qId);
    }, [canAdd, defaultQT, canAllQuestionsBeSkipped, _getClone, _doUpdate]);
    const doAddQuestions = (0, react_1.useMemo)(() => (afterQId, newQs) => {
        const newDB = _getClone();
        (0, addQuestions_1.default)(newDB, afterQId, newQs, true);
        _doUpdate(newDB);
    }, [_doUpdate, _getClone]);
    const doAddSubQuestions = (0, react_1.useMemo)(() => (parentListId, idx, newQs, selectIt = false) => {
        const newDB = _getClone();
        (0, addSubQuestions_1.default)(newDB, parentListId, idx, newQs);
        if (selectIt) {
            selected.current = newQs[0].qId;
            fullySelected.current = newQs[0].qId;
            setSelCtxChanged(new Date());
        }
        _doUpdate(newDB);
    }, [_doUpdate, _getClone]);
    const doMoveQuestion = (0, react_1.useMemo)(() => (qId, destLid, destIdx) => {
        const newDB = _getClone();
        (0, moveQuestion_1.default)(newDB, qId, destLid, destIdx);
        _doUpdate(newDB);
    }, [_doUpdate, _getClone]);
    // DB CTX
    const dbCtx = (0, react_1.useMemo)(() => {
        const db = history.current[historyCursor.current];
        return {
            questions: db.questions,
            lists: db.lists,
            canUndo: canUndo.current,
            canRedo: canRedo.current,
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dbCtxChanged]);
    // ------------------
    // EXPAND CONTROLLER
    // ------------------
    const doExpand = (0, react_1.useMemo)(() => (qId, force) => {
        if (_doExpand(qId, force))
            setExpCtxChanged(new Date());
    }, [_doExpand]);
    // EXPANDS CTX
    const expCtx = (0, react_1.useMemo)(() => ({
        expands: expands.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [expCtxChanged]);
    // ------------------
    // SELECT CONTROLLER
    // ------------------
    if (!selected.current) {
        const rootList = _getDB().lists['root'];
        if ((_a = rootList === null || rootList === void 0 ? void 0 : rootList.childQIds) === null || _a === void 0 ? void 0 : _a.length) {
            selected.current = rootList.childQIds[0];
            setSelCtxChanged(new Date());
        }
    }
    // The following sets the fullySelected property only
    // after we've been selected for a while (150 ms)
    // this speeds up list selection when using arrow keys
    const isFullySelected = (0, useDebouncedValue_1.default)(selected.current, 150);
    (0, react_1.useEffect)(() => {
        if (isFullySelected === selected.current && isFullySelected !== fullySelected.current) {
            fullySelected.current = selected.current;
            setSelCtxChanged(new Date());
        }
    }, [isFullySelected]);
    const doChangeSelect = (0, react_1.useMemo)(() => (dir, ignoreKids = false) => {
        const db = _getDB();
        let sel = selected.current ? db.questions[selected.current] : undefined;
        switch (dir) {
            case -3:
                sel = (0, getPreviousQuestion_1.default)(db, sel, 100000);
                break;
            case -2:
                sel = (0, getPreviousQuestion_1.default)(db, sel, 10);
                break;
            case -1:
                sel = (0, getPreviousQuestion_1.default)(db, sel, 1, ignoreKids);
                break;
            case 1:
                sel = (0, getNextQuestion_1.default)(db, sel, 1, ignoreKids);
                break;
            case 2:
                sel = (0, getNextQuestion_1.default)(db, sel, 10);
                break;
            case 3:
                sel = (0, getNextQuestion_1.default)(db, sel, 100000);
                break;
        }
        selected.current = sel === null || sel === void 0 ? void 0 : sel.qId;
        setSelCtxChanged(new Date());
    }, [_getDB]);
    const doSelect = (0, react_1.useMemo)(() => (qId, fully) => {
        const db = _getDB();
        if (selected.current === qId)
            return;
        selected.current = qId;
        if (fully)
            fullySelected.current = qId;
        const q = db.questions[qId];
        if (q === null || q === void 0 ? void 0 : q.parentListId) {
            const parentList = db.lists[q.parentListId];
            if (parentList === null || parentList === void 0 ? void 0 : parentList.parentQId)
                doExpand(parentList.parentQId, true);
        }
        setSelCtxChanged(new Date());
    }, [_getDB, doExpand]);
    const doSelectChild = (0, react_1.useMemo)(() => (qId, value) => {
        var _a, _b, _c;
        const db = _getDB();
        const childListIds = (_a = db.questions[qId]) === null || _a === void 0 ? void 0 : _a.childListIds;
        const childListId = childListIds.find(l => { var _a; return ((_a = db.lists[l]) === null || _a === void 0 ? void 0 : _a.label) === value; });
        const questionId = (_c = (_b = db.lists[childListId]) === null || _b === void 0 ? void 0 : _b.childQIds) === null || _c === void 0 ? void 0 : _c[0];
        if (questionId) {
            doSelect(questionId);
        }
    }, [_getDB, doSelect]);
    const doSetTreeFocus = (0, react_1.useMemo)(() => (v) => {
        treeFocus.current = v;
        setSelCtxChanged(new Date());
    }, []);
    // SELECT CTX
    const selCtx = (0, react_1.useMemo)(() => ({
        selected: selected.current,
        fullySelected: fullySelected.current,
        treeFocus: treeFocus.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selCtxChanged]);
    // ------------------
    // CNP CONTROLLER
    // ------------------
    const doCopyQuestion = (0, react_1.useMemo)(() => (qId) => {
        if (!qId)
            return;
        copied.current = copied.current === qId ? undefined : qId;
        setCnpCtxChanged(new Date());
    }, []);
    const doPasteQuestion = (0, react_1.useMemo)(() => (afterQId) => {
        const db = _getDB();
        if (!afterQId)
            return false;
        if (!copied.current)
            return false;
        const qToCopy = db.questions[copied.current];
        const newQ = (0, cloneQuestion_1.default)(qToCopy);
        doAddQuestions(afterQId, [newQ]);
        doSelect(newQ.qId, true);
        copied.current = undefined;
        setCnpCtxChanged(new Date());
        return true;
    }, [_getDB, doAddQuestions, doSelect]);
    const doPasteText = (0, react_1.useMemo)(() => (afterQId, pastedText) => {
        let config = {};
        config[defaultQT] = {
            enableNA: canAllQuestionsBeSkipped,
        };
        const newQs = pastedText
            .split('\r') // Windows linebreaks
            .join('')
            .split('\n')
            .map(t => t.trim())
            .filter(t => t !== '')
            .map(t => (0, createFormQuestion_1.default)({ title: t, type: defaultQT, config }));
        doAddQuestions(afterQId, newQs);
        doSelect(newQs[newQs.length - 1].qId, true);
    }, [canAllQuestionsBeSkipped, defaultQT, doAddQuestions, doSelect]);
    // CNP CTX
    const cnpCtx = (0, react_1.useMemo)(() => ({
        copied: copied.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cnpCtxChanged]);
    //--------------
    // DND QuestionSet Controller
    //--------------
    //--------------
    // DND Controller
    //--------------
    const doDragStart = (0, react_1.useMemo)(() => (qId) => {
        dragging.current = qId;
        doSelect(qId);
        setDndCtxChanged(new Date());
    }, [doSelect]);
    const doDragEnd = (0, react_1.useMemo)(() => (destLid, destIdx) => {
        const db = _getDB();
        const q = dragging.current ? db.questions[dragging.current] : undefined;
        dragging.current = undefined;
        if (!q || !destLid)
            return;
        const qId = q.qId;
        const srcIdx = q.parentListIdx;
        const srcLid = q.parentListId;
        if (destIdx === srcIdx && destLid === srcLid)
            return;
        doMoveQuestion(qId, destLid, destIdx);
        setDndCtxChanged(new Date());
    }, [_getDB, doMoveQuestion]);
    const canDrop = (0, react_1.useMemo)(() => (destLid, destIdx, type) => {
        const db = _getDB();
        if (!type && !!dragging.current)
            type = db.questions[dragging.current].type;
        if (!type)
            return false;
        let constraints;
        if (destLid === 'root') {
            constraints = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints.root;
        }
        else {
            const q = db.questions[db.lists[destLid].parentQId];
            if (q.type === FormQuestionType_1.default.QUESTIONSET)
                return false;
            const ancestors = (0, getQuestionAncestors_1.getQuestionAncestors)(db, q);
            if (ancestors.some(a => a.type === FormQuestionType_1.default.QUESTIONSET))
                return false;
            constraints = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[q.type];
        }
        if (!constraints || !constraints.types)
            return true;
        return constraints.types.indexOf(type) >= 0;
    }, [_getDB, formConstraints]);
    // CTX
    const dndCtx = (0, react_1.useMemo)(() => ({
        dragging: dragging.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dndCtxChanged]);
    //--------------
    // KEYDOWN Handling
    //--------------
    const doKeyDown = (0, react_1.useMemo)(() => (e, qId, newTitle) => {
        const db = _getDB();
        let selectFnc;
        if (!qId && db.questions[selected.current].parentListId === 'root') {
            qId = selected.current;
        }
        const q = db.questions[qId];
        const shift = !!e.shiftKey;
        const cmd = e.ctrlKey || e.metaKey;
        const titleProvided = newTitle !== undefined;
        const isDirty = titleProvided && q && newTitle !== q.title;
        let dir;
        switch (e.keyCode) {
            case KeyCodes_1.default.ESC:
                e.preventDefault();
                e.stopPropagation();
                break;
            case KeyCodes_1.default.ENTER:
                e.preventDefault();
                e.stopPropagation();
                // Pressing enter on a question without a title
                // will simply delete it
                if (q && newTitle === '') {
                    doDelete(qId);
                }
                else {
                    // Pressing enter on a question with a
                    // title that needs persisting will add a new item
                    // then go back and persist the other one
                    // (this way round is purposeful for speed
                    // optimization when saving the form)
                    if (q && isDirty)
                        doChangeQuestion(qId, { title: newTitle }, () => {
                            doAdd(qId, doSelect);
                        });
                    // Otherwise, just add new item
                    else
                        doAdd(qId, doSelect);
                }
                break;
            case KeyCodes_1.default.Z:
                // UNDO should let the browser do its thing
                // if the title is dirty
                // otherwise, we take over
                if (cmd) {
                    e.stopPropagation();
                    if (isDirty)
                        return;
                    e.preventDefault();
                    doChangeHistory(shift ? -1 : +1);
                }
                break;
            case KeyCodes_1.default.TAB:
                e.preventDefault();
                e.stopPropagation();
                dir = shift ? -1 : +1;
                selectFnc = () => doChangeSelect(dir);
                if (q && isDirty)
                    doChangeQuestion(qId, { title: newTitle }, selectFnc);
                else
                    selectFnc();
                break;
            case KeyCodes_1.default.UP:
                e.preventDefault();
                e.stopPropagation();
                dir = cmd && shift ? -3 : cmd ? -2 : -1;
                selectFnc = () => doChangeSelect(dir, shift);
                if (q && isDirty)
                    doChangeQuestion(qId, { title: newTitle }, selectFnc);
                else
                    selectFnc();
                break;
            case KeyCodes_1.default.DOWN:
                e.preventDefault();
                e.stopPropagation();
                dir = cmd && shift ? 3 : cmd ? 2 : 1;
                selectFnc = () => doChangeSelect(dir, shift);
                if (q && isDirty)
                    doChangeQuestion(qId, { title: newTitle }, selectFnc);
                else
                    selectFnc();
                break;
            case KeyCodes_1.default.LEFT:
                if (q && shift && !cmd) {
                    e.stopPropagation();
                    e.preventDefault();
                    doExpand(qId, false);
                }
                break;
            case KeyCodes_1.default.RIGHT:
                if (q && shift && !cmd) {
                    e.stopPropagation();
                    e.preventDefault();
                    doExpand(qId, true);
                }
                break;
            case KeyCodes_1.default.BACKSPACE:
                if (q && (titleProvided ? !newTitle : !q.title)) {
                    e.preventDefault();
                    e.stopPropagation();
                    doDelete(qId);
                }
                break;
            case KeyCodes_1.default.C:
                if (q && cmd) {
                    const textSelected = e.target['selectionStart'] !== e.target['selectionEnd'];
                    if (textSelected)
                        return;
                    e.preventDefault();
                    e.stopPropagation();
                    doCopyQuestion(qId);
                }
                break;
            case KeyCodes_1.default.V:
                if (q && cmd) {
                    const textSelected = e.target['selectionStart'] !== e.target['selectionEnd'];
                    if (textSelected)
                        return;
                    if (doPasteQuestion(qId)) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
                break;
        }
    }, [
        _getDB,
        doAdd,
        doChangeHistory,
        doChangeQuestion,
        doChangeSelect,
        doCopyQuestion,
        doDelete,
        doExpand,
        doPasteQuestion,
        doSelect,
    ]);
    // ------------------
    // ACTIONS CONTROLLER
    // ------------------
    const actionCtx = (0, react_1.useMemo)(() => ({
        doUndo,
        doRedo,
        doChangeHistory,
        doReset,
        doMoveQuestion,
        doChangeQuestion,
        doChangeQuestionConfig,
        doDelete,
        doAdd,
        doAddQuestions,
        doAddSubQuestions,
        doExpand,
        doChangeSelect,
        doSelectChild,
        doSelect,
        doCopyQuestion,
        doPasteQuestion,
        doPasteText,
        doKeyDown,
        doDragStart,
        doDragEnd,
        canDrop,
        canAdd,
        doSetTreeFocus,
    }), [
        doUndo,
        doRedo,
        doChangeHistory,
        doReset,
        doMoveQuestion,
        doChangeQuestion,
        doChangeQuestionConfig,
        doDelete,
        doAdd,
        doAddQuestions,
        doAddSubQuestions,
        doExpand,
        doChangeSelect,
        doSelectChild,
        doSelect,
        doCopyQuestion,
        doPasteQuestion,
        doPasteText,
        doKeyDown,
        doDragStart,
        doDragEnd,
        canDrop,
        canAdd,
        doSetTreeFocus,
    ]);
    return (react_1.default.createElement(exports.FedSetupContext.Provider, { value: setupCtx },
        react_1.default.createElement(exports.FedDBContext.Provider, { value: dbCtx },
            react_1.default.createElement(exports.FedExpandContext.Provider, { value: expCtx },
                react_1.default.createElement(exports.FedSelectContext.Provider, { value: selCtx },
                    react_1.default.createElement(exports.FedCnPContext.Provider, { value: cnpCtx },
                        react_1.default.createElement(exports.FedDndContext.Provider, { value: dndCtx },
                            react_1.default.createElement(exports.FedActionsContext.Provider, { value: actionCtx }, children))))))));
}
exports.FedController = FedController;
exports.default = FedController;
exports.FedSetupContext = react_1.default.createContext(null);
exports.FedDBContext = react_1.default.createContext(null);
exports.FedExpandContext = react_1.default.createContext(null);
exports.FedSelectContext = react_1.default.createContext(null);
exports.FedCnPContext = react_1.default.createContext(null);
exports.FedDndContext = react_1.default.createContext(null);
exports.FedActionsContext = react_1.default.createContext(null);
function calcDefaultQTs(formConstraints) {
    var _a, _b, _c, _d;
    let defaultQT = FormQuestionType_1.default.CHECK;
    let defaultSubQT = FormQuestionType_1.default.CHECK;
    // Calculate defaultQT
    const rootC = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints.root;
    if (((_a = rootC === null || rootC === void 0 ? void 0 : rootC.types) === null || _a === void 0 ? void 0 : _a.length) && ((_b = rootC === null || rootC === void 0 ? void 0 : rootC.types) === null || _b === void 0 ? void 0 : _b.indexOf(defaultQT)) < 0) {
        defaultQT = rootC.types[0];
    }
    // Calculate default Sub QT
    const subC = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[defaultQT];
    if (((_c = subC === null || subC === void 0 ? void 0 : subC.types) === null || _c === void 0 ? void 0 : _c.length) && ((_d = subC === null || subC === void 0 ? void 0 : subC.types) === null || _d === void 0 ? void 0 : _d.indexOf(defaultSubQT)) < 0) {
        defaultSubQT = subC === null || subC === void 0 ? void 0 : subC.types[0];
    }
    if (defaultSubQT === FormQuestionType_1.default.QUESTIONSET)
        defaultSubQT = null;
    return { defaultQT, defaultSubQT };
}
